import { NgModule } from '@angular/core';

import { PlaceOrderSmsComponent } from './sms.component';
import { PlaceOrderModule } from '@schoolbelle/shared/components';

@NgModule({
  declarations: [PlaceOrderSmsComponent],
  imports: [
    PlaceOrderModule,
  ],
  exports : [PlaceOrderSmsComponent],
})
export class PlaceOrderSmsModule { }
